module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "panel center-block",
    attrs: {
      "id": "loginForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('h1', [_vm._v("Welcome to DCPNS")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Please go to  "), _c('a', {
    attrs: {
      "href": "https://ops.diningcity.asia"
    }
  }, [_vm._v("ops.diincity.asia")]), _vm._v(" to login.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Or you've logged in back to "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("home page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cdd80bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 37
// module chunks = 1